export const SERVICE_URL = process.env.SERVICE_URL;
export const SITE_URL = process.env.SITE_URL;
export const BLOB_URL = process.env.BLOB_URL;
export const PRINT_URL = process.env.PRINT_URL;
export const AUTH0_REDIRECT = process.env.AUTH0_REDIRECT;
export const AUTH0_DOMAIN = process.env.AUTH0_DOMAIN;
export const AUTH0_AUDIENCE = process.env.AUTH0_AUDIENCE;
export const AUTH0_CLIENTID = process.env.AUTH0_CLIENTID;
export const AUTH0_SCOPE =
  "openid profile manage:images manage:addresses manage:orders";

export const ALERT_TYPE_ERROR = "Error";
export const ALERT_TYPE_SUCCESS = "Success";

export const ACTION_ADD_ALERT = "ACTION_ADD_ALERT";
export const ACTION_DISMISS_ALERT = "ACTION_DISMISS_ALERT";
export const ACTION_INITIALIZE_ORDER = "ACTION_INITIALIZE_ORDER";

export const PLASTIC_TYPE_THEM = "Them";
export const PLASTIC_TYPE_ME = "Me";
export const PLASTIC_TYPE_NO_CARRIER = "No Carrier";
export const EMAIL_TYPE_NOW = "Now";
export const EMAIL_TYPE_LATER = "Later";
export const CARD_TYPE_PLASTIC = "Plastic";
export const CARD_TYPE_EMAIL = "Email";
export const CARD_TYPE_PRINTER = "Printer";
